import { Application } from "@hotwired/stimulus"
import jQuery from "jquery"
import { Turbo } from "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"
import Sortable from "sortablejs"
import Chart from "chart.js/auto"

const application = Application.start()


application.debug = false
Turbo.session.drive = false
window.Stimulus   = application
window.jQuery = window.$ = jQuery
window.bootstrap = bootstrap
window.Sortable = Sortable

document.addEventListener("turbo:load", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new bootstrap.Tooltip(el)
  })

  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
    new bootstrap.Popover(el)
  })
})



export { application }


